import { useEffect, useState } from "react";
import getGame from "../../api/getGame";
import Button from "../Button";
import SnakeBlock from "../SnakeBlock"
import { getDateUSAFormat } from "../../utils/getUserCurrentDate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import getActorById from "../../api/getActorById";
import getMediaById from "../../api/getMediaById";
import createShareURL from "../../utils/createShareURL";
import { checkCurrentMemory } from "../../utils/localStorage";
import "./DaysStats.css"; 

export default function DaysStats({ blocks, strikes, head, tail, gameStatus }) {

  const [loading, setLoading] = useState(false);
  const [rotate, setRotate] = useState(false);
  const [puzzleInfo, setPuzzleInfo] = useState(null);
  const [actor, setActor] = useState(null);
  const [media, setMedia] = useState(null);

  useEffect(() => {
    updateGameInfo();
  }, []);

  const updateGameInfo = async () => {
    setRotate(true);
    setTimeout(() => setRotate(false), 3000);
    setLoading(true);
    const gameData = await getGame();
    setPuzzleInfo(gameData);
    setLoading(false);
    if (gameData?.most_common_media_id) {
      const mediaData = await getMediaById(gameData.most_common_media_id);
      setMedia(mediaData);
    }
    if (gameData?.most_common_actor_id) {
      const actorData = await getActorById(gameData.most_common_actor_id);
      setActor(actorData);
    }
  };

  const daysStats = () => {
    const shortestPath = puzzleInfo?.minimum_score_path;
    const longestPath = puzzleInfo?.maximum_score_path;
    const playCount = puzzleInfo?.play_count;
    const solveCount = puzzleInfo?.completed_count
    const shortestPathLength = shortestPath?.length - 2;
    const longestPathLength = longestPath?.length - 2;
    if (!shortestPath && !longestPath) {
      return (
        <div>
          <p>
            You are the first person to solve today's puzzle!
            <br />
            Check back later to see today's stats.
          </p>
        </div>
      );
    }

    return (
      <div className="stats-container">
      <table className="stats-table">
        <thead>
        <tr>
          <th>Stats for {getDateUSAFormat()}</th>
          <th ><FontAwesomeIcon style={{float:'right'}} className={rotate ? "rotate" : ""} icon={["fas", "sync-alt"]} size="lg" /></th>
        </tr>
        </thead>
        <tbody>
<tr>
          <td>Shortest Path</td>
          <td>
            <a 
              href={createShareURL(blocks?.length < shortestPathLength && blocks?.length !== 0 ? blocks : shortestPath,head, tail, strikes)}
              style={{float:'right', color: 'rgba(14, 183, 39, 1)'}}
            >
              {blocks?.length < shortestPathLength && blocks?.length !== 0 ? blocks?.length : shortestPathLength}
            </a>
          </td>
        </tr>
        <tr>
          <td>My Path</td>
          <td>
            <a href={createShareURL(blocks, head, tail, strikes)} style={{float:'right', color: 'rgba(14, 183, 39, 1)'}}>
              {gameStatus === 'game won' ? blocks.length : 'N/A'}
            </a>
          </td>
        </tr>
        <tr>
          <td>Longest Path</td>
          <td>
          <a href={createShareURL(blocks?.length > longestPathLength ? blocks : longestPath, head, tail, strikes)}  style={{float:'right',color: 'rgba(14, 183, 39, 1)'}}>
            {blocks?.length > longestPathLength ? blocks?.length : longestPathLength}
          </a>
          </td>
        </tr>
        <tr>
          <td>Total Plays</td>
          <td style={{textAlign:'right'}}>{playCount}</td>
        </tr>
        <tr>
          <td>% Solved</td>
          <td style={{textAlign:'right'}}>{Math.floor(solveCount/playCount * 100)}%</td>
        </tr>
        <tr>
          <td colSpan="2" style={{textAlign:'center'}}>
                <p style={{fontWeight:'bold'}}>
                  Most Popular Actor
                </p>
                <div style={{display:'flex', justifyContent:'center'}}>
                    {actor && (<SnakeBlock info={{...actor, type:"ACTOR"}} showGoBack={()=>{}}/>)}
                </div>
          </td>
        </tr>
        <tr>
          <td colSpan="2" style={{textAlign:'center'}}>
                <p style={{fontWeight:'bold'}}>
                  Most Popular Movie
                </p>
                <div style={{display:'flex', justifyContent:'center'}}>
                  {media && (<SnakeBlock info={{...media, type:"MEDIA"}} showGoBack={()=>{}}/>)}
                </div>
          </td>
        </tr>
        </tbody>
      </table>
      </div>
    );
  };

  return (
    <div className="stats-wrapper">
      {daysStats()}
    </div>
  );
}
